import { render, staticRenderFns } from "./MyRewards.vue?vue&type=template&id=5de0c4cd&scoped=true"
import script from "./MyRewards.vue?vue&type=script&lang=js"
export * from "./MyRewards.vue?vue&type=script&lang=js"
import style0 from "./MyRewards.vue?vue&type=style&index=0&id=5de0c4cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de0c4cd",
  null
  
)

export default component.exports